<template>
  <a-form>
    <a-form-item label="Secret" name="secret">
      <a-input type="text" v-model:value="entity.secret" readonly />
    </a-form-item>

    <a-form-item label="注册码" name="activateCode">
      <a-input type="text" v-model:value="entity.activateCode" />
    </a-form-item>

    <a-form-item label="有效期" name="exp">
      <a-input type="text" v-model:value="entity.exp" readonly />
    </a-form-item>

    <div style="width: 100%;text-align: center" class="mt-4">
      <a-button type="primary" @click="onSubmit">提交</a-button>
    </div>

  </a-form>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import request from "../common/request";
import { message } from "ant-design-vue";

const emit = defineEmits(['success']);

let entity = ref({
  secret: '',
  activateCode: '',
  exp: ''
})

onMounted(async () => {
  await getActiveInfo();
})

const getActiveInfo = async () => {
  let result = await request.get('/draw/api/activated')
  if (result?.data) {
    entity.value.secret = result.data.mac_code;
    entity.value.activateCode = result.data.activation_code?.code;
    entity.value.exp = result.data.activation_code?.exp;
  }
}

const onSubmit = async () => {
  if (!entity.value.activateCode) {
    return;
  }
  let result: any = await request.post("/draw/api/activated", { code: entity.value.activateCode });
  if (result?.data) {
    message.success('保存成功');
    await getActiveInfo();
    emit('success');
  } else {
    message.error('注册码无效')
  }

}
</script>